// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OanHPqScidH07TILvFS_ {\n  display: grid;\n  justify-content: center;\n}\n.Wswkht0Zc2_Wj5QEbOqL {\n  margin: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/components/mascotas-cercanas/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;AACd","sourcesContent":[".mascotas-cercanas-container {\n  display: grid;\n  justify-content: center;\n}\n.spinner {\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mascotas-cercanas-container": "OanHPqScidH07TILvFS_",
	"spinner": "Wswkht0Zc2_Wj5QEbOqL"
};
export default ___CSS_LOADER_EXPORT___;
